import { useLoaderData, redirect } from "react-router";
import { FaSuitcaseRolling, FaCalendarCheck } from "react-icons/fa";

import { Api, Types } from "@/services";
import { StatItem, StatsContainerWrapper } from "@/components";

export const adminLoader = async () => {
  try {
    const { data } = await Api.ApplicationStats();
    return data;
  } catch (err) {
    return redirect("/dashboard");
  }
};

const Admin = () => {
  const { totalUsers, totalJobs } = useLoaderData<Types.Response.ApplicationStats>();

  return (
    <StatsContainerWrapper>
      <StatItem count={totalUsers} title="current users" color="#e9b949" bgColor="#fcefc7" icon={<FaSuitcaseRolling />} />
      <StatItem count={totalJobs} title="total jobs" color="#647acb" bgColor="#e0e8f9" icon={<FaCalendarCheck />} />
    </StatsContainerWrapper>
  );
};

export default Admin;
